import { render, staticRenderFns } from "./titlePage.vue?vue&type=template&id=5c2e143b&scoped=true"
import script from "./titlePage.vue?vue&type=script&lang=js"
export * from "./titlePage.vue?vue&type=script&lang=js"
import style0 from "./titlePage.vue?vue&type=style&index=0&id=5c2e143b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e143b",
  null
  
)

export default component.exports